// extracted by mini-css-extract-plugin
export default {"layout":"_5D36TH-l","mobile-button":"_5D2oH7vA","desktop-button":"_5D3wAFey","terms-link":"_5D102Ml1"};